import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const myUserTask = z
  .object({
    id: z.string().hidden().describe('Unique identifier'),

    userTaskId: z.string().describe('The underlying user task id'),

    referenceNumber: z
      .number()
      .nullable()
      .optional()
      .describe('Human-readable reference number'),

    name: z
      .string()
      .nullable()
      .optional()
      .describe('Optional name for this task'),

    status: z
      .enum(['Active', 'Paused', 'Complete', 'Canceled'])
      .nullable()
      .optional()
      .describe('Current state of this task'),

    data: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe('In-progress working data for this task'),

    completedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this task was finished'),

    candidateUserId: z
      .number()
      .nullable()
      .optional()
      .describe(
        'The user who can see this task based on role or direct assignment',
      ),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this task was created'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this task was last updated'),

    roleId: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to Role'),

    userId: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to User'),

    tokenId: z.uuid().hidden().describe('Foreign key to Token'),

    role: references('Role', 'roleId'),

    user: references('User', 'userId'),

    token: belongsTo('Token'),
  })
  .describe(
    'User tasks visible to a specific user, either directly assigned or available through a role assignment',
  )
  .as('MyUserTask');

export { myUserTask as myUserTaskSchema };
